/** Live, high-traffic routes we steer a lost visitor toward. */
export const LEAN_ESCAPE_ROUTES = [
  {
    path: '/',
    label: 'Go to Home',
  },
  {
    path: '/features',
    label: 'See Features',
  },
  {
    path: '/contact',
    label: 'Get in touch',
  },
] as const;
